import React from 'react';
import moment from 'moment';

const CreatedTimeComponent = ({ createdTime }) => {
  // Convert the input string to a Moment.js object
  const createdMoment = moment(createdTime, 'DD-MM-YYYY HH:mm');

  // Function to get the human-readable time difference or formatted date
  const getTimeDisplay = () => {
    const now = moment();

    // If the time is less than 24 hours ago, show relative time like "X hours ago"
    if (now.diff(createdMoment, 'hours') < 24) {
      return createdMoment.fromNow(); // "2 hours ago", "5 minutes ago"
    }

    // If it's exactly yesterday, show "Yesterday"
    if (now.diff(createdMoment, 'days') === 1) {
      return 'Yesterday';
    }

    // If older than yesterday, show the formatted date: "September 12, 2024 at 3:01 PM"
    return createdMoment.format('MMMM D, YYYY [at] h:mm A');
  };

  return (
      <span className='time'>{getTimeDisplay()}</span>
  );
};

export default CreatedTimeComponent;
